<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 26 32"
  >
    <g>
      <path
        fill="#01d17c"
        d="M4.447 21.991c-2.218-2.251-3.587-5.343-3.587-8.756s1.37-6.505 3.589-8.757l-0.002 0.002c2.202-2.238 5.264-3.625 8.65-3.625 0.011 0 0.022 0 0.033 0h-0.002c0.005 0 0.010 0 0.015 0 3.391 0 6.457 1.387 8.664 3.624l0.001 0.001c2.218 2.251 3.587 5.343 3.587 8.756s-1.37 6.505-3.589 8.757l-8.643 8.791z"
      />
      <path
        fill="#464646"
        d="M13.128 1.588c0.004 0 0.010 0 0.015 0 3.191 0 6.078 1.304 8.157 3.408l0.001 0.001c2.090 2.099 3.382 4.995 3.382 8.192 0 0.016-0 0.032-0 0.048v-0.002c0 0.009 0 0.019 0 0.030 0 3.202-1.292 6.103-3.383 8.209l0.001-0.001-8.136 8.266-8.21-8.276c-2.090-2.099-3.382-4.995-3.382-8.192 0-0.016 0-0.032 0-0.048v0.002c-0-0.009-0-0.019-0-0.030 0-3.202 1.292-6.103 3.383-8.209l-0.001 0.001c2.081-2.1 4.966-3.4 8.155-3.4 0.006 0 0.013 0 0.019 0h-0.001zM13.128-0.001c-0.004 0-0.009 0-0.014 0-3.627 0-6.908 1.483-9.269 3.875l-0.001 0.001c-2.376 2.404-3.843 5.71-3.843 9.359s1.468 6.955 3.845 9.36l-0.001-0.001 9.322 9.406 9.248-9.396c2.376-2.404 3.843-5.71 3.843-9.359s-1.468-6.955-3.845-9.36l0.001 0.001c-2.362-2.399-5.645-3.886-9.275-3.886-0.004 0-0.007 0-0.011 0h0.001z"
      />
      <path
        fill="#464646"
        d="M20.742 15.512h-14.626v-8.084c0-0.001 0-0.003 0-0.004 0-0.337-0.273-0.61-0.61-0.61-0.001 0-0.002 0-0.003 0h0c-0.001 0-0.002 0-0.003 0-0.337 0-0.61 0.273-0.61 0.61 0 0.001 0 0.003 0 0.004v-0 11.844c0 0.001 0 0.002 0 0.003 0 0.337 0.273 0.61 0.61 0.61 0.001 0 0.002 0 0.003 0h-0c0.001 0 0.002 0 0.003 0 0.337 0 0.61-0.273 0.61-0.61 0-0.001 0-0.002 0-0.003v0-2.524h14.016v2.654c0 0.001 0 0.002 0 0.003 0 0.337 0.273 0.61 0.61 0.61 0.001 0 0.003 0 0.004 0h-0c0.001 0 0.003 0 0.004 0 0.337 0 0.61-0.273 0.61-0.61 0-0.001 0-0.002 0-0.003v0-3.278c0-0.001 0-0.002 0-0.003 0-0.337-0.273-0.61-0.61-0.61-0.003 0-0.006 0-0.009 0h0z"
      />
      <path
        fill="#464646"
        d="M20.601 12.002h-12.99c-0.372 0-0.674 0.302-0.674 0.674v0 1.357c0 0.372 0.302 0.674 0.674 0.674v0h12.99c0.372 0 0.674-0.302 0.674-0.674v0-1.357c0-0.372-0.302-0.674-0.674-0.674v0z"
      />
      <path
        fill="#464646"
        d="M7.62 9.378c1.106 0 3.528 0.633 3.701 1.649 0.001 0.008 0.002 0.018 0.002 0.027 0 0.091-0.073 0.164-0.164 0.164-0.001 0-0.002 0-0.002-0h-3.54c-0.372 0-0.674-0.302-0.674-0.674v0-0.492c0-0 0-0.001 0-0.001 0-0.372 0.302-0.674 0.674-0.674 0.001 0 0.002 0 0.003 0h-0z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
